import { useLocation } from "react-router-dom";

import { VerifyTotpForm } from "@/features/sign-in/components/verify-totp.form";

export function VerifyEmail() {
  const location = useLocation();
  const email: string | undefined = location.state?.email;

  return (
    <div>
      <div className="px-4 sm:px-6">
        <p className="text-lg font-medium text-foreground">
          Two-step verification
        </p>
        <p className="text-base font-normal text-muted">
          To continue, please enter the verification code <br /> sent to{" "}
          <span className="font-medium">
            {email ? email : "your email address"}.
          </span>
        </p>
        <div className="my-8 sm:my-11">
          <VerifyTotpForm />
        </div>
      </div>
    </div>
  );
}
